import React from 'react';
import Loading from './Loading/Loading';

const ProcessingLabel = ({show, message}) => {
    return (
        <div style={{
            display: "flex",
            alignItems: "center",
            marginTop: 10,
            visibility: show ? 'visible' : 'hidden'
        }}>
        <Loading width={14} height={14} />
        <span style={{
            fontSize: 14,
            lineHeight: "16px",
            color: "var(--turquoiseDark2)",
            marginLeft: 5
        }}>
            {message}
        </span>
    </div>
    )
}

export default ProcessingLabel;
